import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue';
import RegisterView from '@/views/RegisterView.vue';
import LoginView from '@/views/LoginView.vue';
import ModernDashboardView from '@/views/ModernDashboardView.vue';
import ProfileView from '@/views/ProfileView.vue';
import EditProceedingView from '@/views/EditProceedingView.vue';
import store from '@/store'; // NEW
import ProceedingView from '@/views/ProceedingView.vue';
import AddProceedingView from '@/views/AddProceedingView.vue';
import NotificationsView from '@/views/NotificationView.vue';
import AddNotificationView from '@/views/AddNotificationView.vue';
import EditNotificationView from '@/views/EditNotificationView.vue';
import ValidateAccountView from '@/views/ValidateAccountView.vue'
import ModernNotificationView from '@/views/ModernNotificationView.vue';

const routes = [
  {
    path: '/',
    name: "Home",
    component: HomeView,
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: ModernDashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView,
    meta: { requiresAuth: true },
  },
  {
    path: '/proceedings/add',
    name: 'AddProceeding',
    component: AddProceedingView,
    meta: { requiresAuth: true },
    props: true,
  }
  ,
  {
    path: '/proceedings/:id',
    name: 'Proceeding',
    component: ProceedingView,
    meta: { requiresAuth: true },
    props: true,
  }
  ,
  {
    path: '/editproceeding/:id',
    name: 'EditProceeding',
    component: EditProceedingView,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/notifications/:id',
    name: 'Notifications',
    component: NotificationsView,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/notifications/add/:id',
    name: 'AddNotification',
    component: AddNotificationView,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/notification/:proceeding_id/:id',
    name: 'EditNotification',
    component: EditNotificationView,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/validate_account/:token',
    name: 'ValidateAccount',
    component: ValidateAccountView,
    meta: { requiresAuth: false },
    props: true,
  },
  // New routes for SideBar navigation
  {
    path: '/notifications',
    name: 'NotificationsList',
    component: ModernNotificationView,
    meta: { requiresAuth: true },
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: () => import('@/views/DashboardView.vue'), // Using DashboardView as placeholder
    meta: { requiresAuth: true },
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('@/views/DashboardView.vue'), // Using DashboardView as placeholder
    meta: { requiresAuth: true },
  },
  {
    path: '/profile-details',
    name: 'ProfileDetails',
    component: () => import('@/views/ProfileView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/notification-settings',
    name: 'NotificationSettings',
    component: () => import('@/views/DashboardView.vue'), // Using DashboardView as placeholder
    meta: { requiresAuth: true },
  },
  {
    path: '/archived',
    name: 'Archived',
    component: () => import('@/views/DashboardView.vue'), // Using DashboardView as placeholder
    meta: { requiresAuth: true },
  },
  {
    path: '/recent',
    name: 'Recent',
    component: () => import('@/views/DashboardView.vue'), // Using DashboardView as placeholder
    meta: { requiresAuth: true },
  },
  {
    path: '/favorites-menu',
    name: 'FavoritesMenu',
    component: () => import('@/views/DashboardView.vue'), // Using DashboardView as placeholder
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/ConfigThemeView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/payments',
    name: 'Payments',
    component: () => import('@/views/StripePaymentView.vue'),
    meta: { requiresAuth: true },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, _, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthRoute = to.path === '/login' || to.path === '/register' || to.path === '/';
  const isAuthenticated = store.getters.isAuthenticated;

  if (requiresAuth && !isAuthenticated) {
    // Route requires auth but user is not authenticated
    next('/login');
  } else if (isAuthenticated && isAuthRoute) {
    // User is authenticated and trying to access login/register page
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
